import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { threeDTourPlayed } from '@store/actions/videoAnalytics';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const useIFrameInteractionTracking = ({
  shouldTrack,
  sourceContent,
  sourcePage,
  iFrameId,
}) => {
  const isTracking3DTourPlays = useFlags()['track-3d-tour-plays'] || false;
  const dispatch = useDispatch();
  const intervalRef = useRef<NodeJS.Timeout>();
  const shouldTrackAndFlagEnabled = shouldTrack && isTracking3DTourPlays;

  useEffect(() => {
    if (shouldTrackAndFlagEnabled) {
      if (!intervalRef.current) {
        const iframeWatcher = setInterval(() => {
          const { activeElement } = document;
          if (activeElement && activeElement.isEqualNode(document.getElementById(iFrameId))) {
            dispatch(
              threeDTourPlayed({
                sourceContent,
                sourcePage,
              }),
            );
            if (intervalRef.current) {
              clearInterval(intervalRef.current);
              intervalRef.current = undefined;
            }
          }
        }, 100);

        intervalRef.current = iframeWatcher;
      }
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [shouldTrackAndFlagEnabled]);
};

export default useIFrameInteractionTracking;
